import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdminResetPassword } from "helpers/api_method";

export const adminChangePassword = createAsyncThunk("adminPassword/adminChangePassword", async (event: any, { rejectWithValue }) => {
    try {
        const response = (await AdminResetPassword(event)) as any;
        
        // The interceptor returns the full response object
        // Backend returns: { status: true, message: "...", data: {...} }
        if (response && response.status === true) {
            return {
                success: true,
                message: response.message || "Password changed successfully",
                data: response.data || {}
            };
        } else if (response && response.status === false) {
            // Backend returned an error response
            return rejectWithValue({
                message: response.message || "Failed to change password",
                data: response.data || {}
            });
        }
        
        // If response doesn't have expected structure, check if it's an error string
        if (typeof response === 'string') {
            return rejectWithValue({
                message: response,
                data: {}
            });
        }
        
        // If response structure is unexpected but exists, treat as success
        return { 
            success: true, 
            message: "Password changed successfully",
            data: response || {} 
        };
    } catch (error: any) {
        // Enhanced error handling for different error types
        let errorMessage = "Failed to change password";
        
        if (error?.response?.data) {
            // Axios error with response data
            const errorData = error.response.data;
            if (errorData.message) {
                errorMessage = errorData.message;
            } else if (errorData.error) {
                errorMessage = errorData.error;
            } else if (typeof errorData === 'string') {
                errorMessage = errorData;
            }
        } else if (error?.message) {
            errorMessage = error.message;
        } else if (typeof error === 'string') {
            errorMessage = error;
        }
        
        return rejectWithValue({
            message: errorMessage,
            data: {},
            error: error
        });
    }
});
